import { FC } from 'react';

import { ContactType as ContactTypeType } from '@/shared/lib/sj-orm/models/contact.dto';

import { useI18nValues } from '../hooks/useI18nValues';

type ContactTypeI18nProps = {
  type: ContactTypeType;
};

export const ContactTypeI18n: FC<ContactTypeI18nProps> = ({ type }) => {
  const values = useI18nValues();

  return <>{values.type(type)}</>;
};
